import React, { useEffect, useLayoutEffect, useRef, useMemo } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import ScrollToTopPage from '../../components/ScrollToTopPage';
import claimSteps from './claimSteps';
import { CLAIM_TYPES } from '../../constants';
import CompensationContainer from '../CompensationContainer';
import { clearPropertyForm, updatePropertyForm, setLanguage } from '../../redux/modules/propertyClaim';
import { clearApplicantSearch } from '../../redux/modules/searchApplicant';
import { updateClaimForm } from '../../helpers/claims/claimApplicationHelpers';
import { getCountries, getStates } from '../../redux/modules/countries';
import { getDamageCauses, getOrganizations } from '../../redux/modules/claimApplication';
import { bindPropertyClaimConclusionSuccessTableData } from '../../helpers/claims/propertyClaim';

import PropertyClaim from '../../img/claims/propertyClaim.svg';

const PropertyCompensationContainer = () => {
  const { i18n, t } = useTranslation();

  const dispatch = useDispatch();

  const currentLanguage = useRef(i18n.language);
  const propertyClaim = useSelector((store) => store.propertyClaim, shallowEqual);
  const countries = useSelector((store) => store.countriesReducer.countries);

  const {
    searchData,
  } = useSelector((store) => store.searchApplicant);

  useEffect(() => {
    dispatch(getCountries());
    dispatch(getStates());
    dispatch(getDamageCauses());
    dispatch(getOrganizations());
  }, [dispatch]);

  useLayoutEffect(() => {
    dispatch(setLanguage(currentLanguage.current));
  }, [dispatch]);

  useEffect(
    () => () => {
      dispatch(clearPropertyForm());
      dispatch(clearApplicantSearch());
    },
    [dispatch],
  );

  useEffect(() => {
    updateClaimForm(dispatch, updatePropertyForm, searchData);
  }, [searchData, countries, dispatch]);

  const claimSuccessData = useMemo(
    () => {
      if (propertyClaim.submitSuccess) {
        return bindPropertyClaimConclusionSuccessTableData(propertyClaim, t);
      }
      return undefined;
    },
    [propertyClaim, t],
  );

  return (
    <>
      <ScrollToTopPage />
      <CompensationContainer
        claimSteps={claimSteps}
        claim={propertyClaim}
        headerText="claim.propertyClaimHeaderText"
        headerImage={PropertyClaim}
        type={CLAIM_TYPES.PROPERTY}
        clearForm={clearPropertyForm}
        clearApplicantSearch={clearApplicantSearch}
        formLanguage={propertyClaim.language}
        claimSuccessData={claimSuccessData}
      />
    </>
  );
};

export default PropertyCompensationContainer;
